import { dummyHeatMap, dummyInitialGraphData } from "../dummyData";
import {
  handleError,
  handleRequestError,
  jsonHeaders,
  message,
  plServerUrl,
  request,
  withResponseDummyFallback,
} from "./core";

export const getIntialData = async (selectedDate) => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: plServerUrl(`/users/gdata?date=${selectedDate}`),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) =>
      withResponseDummyFallback(response, dummyInitialGraphData),
    )
    .catch((error) => handleRequestError(error, dummyInitialGraphData));
};

export const getIntialStockData = async (selectedDate, symbol) => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: plServerUrl(
      `/users/sdata?date=${selectedDate}&symbol=${encodeURIComponent(symbol)}`,
    ),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) =>
      withResponseDummyFallback(response, dummyInitialGraphData),
    )
    .catch((error) => handleRequestError(error, dummyInitialGraphData));
};

export const getIntialStockDataWithLTP = async (selectedDate, symbol) => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: plServerUrl(
      `/users/averagedata?date=${
        selectedDate || new Date()
      }&symbol=${encodeURIComponent(symbol)}`,
    ),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) => withResponseDummyFallback(response, dummyHeatMap))
    .catch((error) => handleRequestError(error, dummyHeatMap));
};

export const getHeatMapData = async () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: plServerUrl("/users/heatMap"),
    headers: jsonHeaders(),
  };
  return request(config).catch((error) => {
    handleError(error);
    message.error(error?.response?.data?.message || "Server is Down");
  });
};
